import React from 'react';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

class Content extends React.Component {

  static defaultProps = {
    className: 'content2',
  };

  getDelay = e => e % 3 * 100 + Math.floor(e / 3) * 100 + 300;

  render() {
    const props = { ...this.props };
    delete props.isMode;
    const oneAnim = { y: '+=30', opacity: 0, type: 'from', ease: 'easeOutQuad' };
    const blockArray = [
      { icon: 'http://www.hooyee.xyz/images/site.svg', title: '高端定制网站', content: '企业高端定制网站设，您提供量身打造的网站解决方案，彰显企业品牌形象。' },
      { icon: 'http://www.hooyee.xyz/images/wap.svg', title: '移动站点', content: '定制手机网站、微网站制作，助力企业布局移动互联网。' },
      { icon: 'http://www.hooyee.xyz/images/wx.svg', title: '微信平台开发', content: '为您提供托管式的微信服务号、公众号、企业微信、小程序定制开发。' },
      { icon: 'http://www.hooyee.xyz/images/ecommerce.svg', title: '电子商务', content: '水果、玩具、服装、专业设备等各类电子商务平台、支持移动平台和移动支付、支持整合微信服务号、提供定制化的微商服务' },
      { icon: 'http://www.hooyee.xyz/images/app.svg', title: '移动APP开发', content: '提供Android、iOS的APP研发，实现地理位置的动态追踪、基于手机的体感互动、蓝牙、NFC设备识别等各类与手机设备密切关联的APP应用' },
      { icon: 'http://www.hooyee.xyz/images/monitor.svg', title: '业务系统研发', content: '基于C/S、B/S框架研发针对于特定场景的业务系统。包括但不限于生产监控系统、溯源系统、SCM系统、ERP、CRM等系统设计和研发。' },
    ];
    const children = blockArray.map((item, i) => {
      const id = `block${i}`;
      const delay = this.getDelay(i);
      const liAnim = { opacity: 0, type: 'from', ease: 'easeOutQuad', delay };
      const childrenAnim = { ...liAnim, x: '+=10', delay: delay + 100,};
      return (<TweenOne
        component="li"
        animation={liAnim}
        key={i}
        id={`${props.id}-${id}`}
      >
        <TweenOne
          animation={{ x: '-=10', opacity: 0, type: 'from', ease: 'easeOutQuad' }}
          className="img"
          key="img"
        >
          <img src={item.icon} width="100%" alt=""/>
        </TweenOne>
        <div className="text">
          <TweenOne key="h1" animation={childrenAnim} component="h1">
            {item.title}
          </TweenOne>
          <TweenOne key="p" animation={{ ...childrenAnim, delay: delay + 200 }} component="p">
            {item.content}
          </TweenOne>
        </div>
      </TweenOne>);
    });
    return (
      <div {...props} className={`content-template-wrapper ${props.className}-wrapper`}>
        <OverPack
          className={`content-template ${props.className}`}
          location={props.id}
          id='service'
        >
          <TweenOne
            key="h1"
            animation={oneAnim}
            component="h1"
            id={`${props.id}-title`}
            reverseDelay={100}
          >
             我们提供专业的服务
          </TweenOne>
          <TweenOne
            key="p"
            animation={{ ...oneAnim, delay: 100 }}
            component="p"
            id={`${props.id}-titleContent`}
          >
            基于回一科技专业、强大的研发资源
          </TweenOne>
          <QueueAnim
            key="ul"
            type="bottom"
            className={`${props.className}-contentWrapper`}
            id={`${props.id}-contentWrapper`}
          >
            <ul key="ul">
              {children}
            </ul>
          </QueueAnim>
        </OverPack>
      </div>
    );
  }
}


export default Content;



// WEBPACK FOOTER //
// ./src/Home/Content1.jsx